export const mysearchReducer = (state = null, action) => {

    switch (action.type) {

        case "research":
            return action.payload;

        case "poll":
            return action.payload;

        case "content":
            return action.payload;

        default:

            return state;


    }
}